import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Plus, Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

export function AssetsPage() {
  return (
    <div className="p-6 lg:p-8">
      <header className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">资产库</h1>
          <p className="mt-1 text-sm text-neutral-600">角色 / 场景 / 道具 / 音色 / BGM · 一键克隆 · 上架资产市场</p>
        </div>
        <div className="flex items-center gap-2">
          <div className="relative">
            <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-outline" />
            <Input className="w-64 pl-9" placeholder="搜索资产" />
          </div>
          <Button>
            <Plus className="h-4 w-4" /> 新建
          </Button>
        </div>
      </header>

      <Tabs defaultValue="character">
        <TabsList>
          <TabsTrigger value="character">角色</TabsTrigger>
          <TabsTrigger value="location">场景</TabsTrigger>
          <TabsTrigger value="prop">道具</TabsTrigger>
          <TabsTrigger value="voice">音色</TabsTrigger>
          <TabsTrigger value="bgm">BGM</TabsTrigger>
        </TabsList>
        <TabsContent value="character">
          <AssetGrid kind="character" />
        </TabsContent>
        <TabsContent value="location">
          <AssetGrid kind="location" />
        </TabsContent>
        <TabsContent value="prop">
          <AssetGrid kind="prop" />
        </TabsContent>
        <TabsContent value="voice">
          <AssetGrid kind="voice" />
        </TabsContent>
        <TabsContent value="bgm">
          <AssetGrid kind="bgm" />
        </TabsContent>
      </Tabs>
    </div>
  );
}

function AssetGrid({ kind }: { kind: string }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
      {Array.from({ length: 12 }).map((_, i) => (
        <Card key={i}>
          <div className="aspect-square bg-gradient-to-br from-brand-100 to-brand-300" />
          <CardHeader className="pb-2">
            <CardTitle className="text-sm">
              {kind}-{String(i + 1).padStart(3, '0')}
            </CardTitle>
          </CardHeader>
          <CardContent className="flex items-center justify-between pb-3 text-xs text-outline">
            <span>v1.2</span>
            <Button variant="ghost" size="sm">
              克隆
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
